"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { HERO_SLIDES } from "@/lib/content";

const HomeHeroEffects = dynamic(
  () => import("./HomeHeroEffects").then((m) => ({ default: m.HomeHeroEffects })),
  { ssr: false },
);

/** Defer carousel JS until idle so hero LCP HTML paints without hydration cost. */
export function DeferredHomeHeroEffects() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const mount = () => setReady(true);
    if (typeof requestIdleCallback === "function") {
      const id = requestIdleCallback(mount, { timeout: 2800 });
      return () => cancelIdleCallback(id);
    }
    const id = window.setTimeout(mount, 200);
    return () => window.clearTimeout(id);
  }, []);

  if (!ready) {
    return (
      <div className="hero-carousel" aria-hidden>
        <div className={`hero-slide ${HERO_SLIDES[0].tone} is-active`} />
      </div>
    );
  }

  return <HomeHeroEffects slides={HERO_SLIDES} />;
}
